import { useState, useRef, useEffect } from "react";
import { useTranslation } from "../../i18n/LanguageContext";

// City combobox: type-to-filter against known options, but also allows freely
// typing a city that is not in the list yet.
function SearchableSelect({ value, onChange, options = [], placeholder }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const resolvedPlaceholder = placeholder || t("filters.searchPlaceholder", "Search…");

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const query = (value || "").toLowerCase();
  const filtered = options.filter((option) => option.toLowerCase().includes(query));

  return (
    <div className="relative" ref={ref}>
      <input
        className="w-full rounded-2xl border border-slate-700 bg-slate-900/95 px-3 py-2 text-sm text-white placeholder-slate-400 shadow-inner outline-none transition focus:border-sky-400"
        placeholder={resolvedPlaceholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />
      {open && filtered.length > 0 && (
        <ul className="absolute z-30 mt-1 max-h-44 w-full overflow-y-auto rounded-2xl border border-slate-700 bg-slate-900 py-1 shadow-2xl">
          {filtered.map((option) => (
            <li key={option}>
              <button
                type="button"
                onClick={() => {
                  onChange(option);
                  setOpen(false);
                }}
                className="block w-full px-3 py-2 text-left text-sm text-slate-200 transition hover:bg-slate-700"
              >
                {option}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SearchableSelect;
